import './App.css';
import {useRef,useState,useEffect,useReducer,useContext} from 'react';
import { Context} from './context';
import React from 'react';
import { FaCalendarAlt } from "react-icons/fa";
import { MdCancel } from "react-icons/md";

import { format } from 'date-fns';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';

import { URL0,blue} from './config';
import { useNavigate } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import 'bootstrap/dist/css/bootstrap.min.css';



function App({filter}) {	
	
	const {state, dispatch} = useContext(Context);	
	const lang = state.lang;
	const eng = state.eng;
	const sc = state.sc;
	const tc = state.tc;
	const attachTypeLabel = state.attachTypeLabel;
	const fileInputRef = useRef(null);	
	const [attachtype,setAttachtype] = useState(filter[0]);	
	const [file, setFile] = useState();
	const [filename, setFilename] = useState();		
	const [uploaded,setUploaded] = useState([]);
	
	useEffect(()=>{
		//console.log(' use effect ' , state.uploaded );
		setUploaded(state.uploaded);
	},[state.uploaded.length]);
	
	useEffect(()=>{
		//console.log(' use effect B ' , state.uploaded.length );
	});
	
	
	function check_valid_format(f){
		
		let warning = {'tc':'只可上傳JPG,GIF,JPEG,PDF,PNG格式',
						'sc':'只可上传JPG,GIF,JPEG,PDF,PNG格式',
						'eng':'Only JPG,GIF,JPEG,PDF,PNG is allowed to upload'
		};
		if (!!f){			
			let g = f.toUpperCase();		
			if (g=='JPEG') return true;
			if (g=='JPG') return true;
			if (g=='PNG') return true;
			if (g=='PDF') return true;
			if (g=='GIF') return true;
			//if (g=='HEIC') return true;
			setTimeout(()=>{
				dispatch({type:'showMsg',value: ''});	
			},500);
			dispatch({type:'showMsg',value:warning[lang]});				
			return false;
		} else {
			return false;
		}
	}
	
	useEffect( ()=> {
		if (!file) {
			return;
		}		
		//console.log( file.type.split('/')[1] );
		if (check_valid_format(file.type.split('/')[1])==false){			
			return ;
		}
		fetch(URL0 + '/post_application.php?action=file&type=' + file.type.split('/')[1], {
			method: 'POST',
			body: file,
			headers: {
				'JWT': localStorage.getItem('jwtapplication1')			
			},
		})
		.then((res) => res.text())
		.then((data) => {				
			data = JSON.parse(data);
			//setUploaded( [ ...uploaded,{cat:attachtype,fn:data['fn'],ofn:filename} ]);
			dispatch({type:'setUploaded',value: [ ...uploaded,{cat:attachtype,fn:data['fn'],ofn:filename} ] });			
			
			if (filter.indexOf('non')!=-1){
				setAttachtype('non');
			}			
			fileInputRef.current.value = '';
		})
		.catch((err) => console.log(err));
		
	},[file]);	
	
	const removeUploaded = (x) => {
		dispatch({type:'setUploaded',value: uploaded.filter(y=>y['fn']!=x['fn']) });							
	}	
	const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
		//console.log('start 1');
		if (e.target.files) {
			//console.log('start 2');			
			try{
				setFile(e.target.files[0]);
				setFilename(e.target.files[0].name);
			}catch(ex){
			}			
		}		
	};
	
	return (
	<Context.Provider value={{state,dispatch}} >	
		
		{/*<span className='smalltitle'> 
		<span style={{...eng}}>Upload a File </span>
		<span style={{...tc}}>上載檔案 </span>
		<span style={{...sc}}>上载档案 </span>
		</span>		*/}

		<select onChange={(e)=> setAttachtype(e.target.value) } defaultValue={attachtype} style={{display:filter[0]=='non'?'block':'none'}}>
		{attachTypeLabel && Object.keys(attachTypeLabel).filter(x=>filter.indexOf(x)!=-1).map(x=>{	
			return <option key={x} value={x} selected={x==attachtype} >{attachTypeLabel[x][lang]}</option>
		})}
		</select>
		<br />

		<input  ref={el=>fileInputRef.current=el} 
			type="file" style={{display:attachtype=='non'?'none':'block'}} 
			onChange={handleFileChange} className=""  />

		<b>
		{uploaded.filter(x=>filter.indexOf(x['cat'])!=-1).length>0 && <>
			<span style={{...eng}}>Uploaded Files</span>
			<span style={{...tc}}>已上載之檔案 </span>
			<span style={{...sc}}>已上载之档案 </span>
		</>}
		</b>				
		{attachTypeLabel && uploaded.filter(x=>filter.indexOf(x['cat'])!=-1).map((x,i)=>{
			return <div key={'upload'+i}> {attachTypeLabel[x['cat']][lang]} : <span style={{color:'red'}}> {x['ofn']}</span> 						
					&nbsp;<input type='button' onClick={()=>removeUploaded(x)} 
					value={(lang=='eng'?"Delete":'') + (lang=='tc'?"刪除":'') + (lang=='sc'?"刪除":'')} /> </div>
		})}		
		<br />	
		{/*JSON.stringify(state.uploaded)*/}
		
	</Context.Provider >
	)
}
		

export default App;
